/* compontents import */
import Products from '../components/products/Products';

const ProductPage = () => {
  return <Products />;
};

export default ProductPage;
